module.exports = __webpack_public_path__ + "img/retail-image-item-4.3e460fbf.png";